const initialState = {
    favdata:[],
    favkfrs:[],
    filtered:[]
}

const reduceer=(state = initialState, action)=>{
  switch (action.type) {

  case "ADDFAV":
    if(!state.favdata.includes(action.data)){
      return { ...state,favdata:[...state.favdata,action.data] }
    }

  case "REMOVEFAV":
    console.log(action.data)
    return{...state,favdata:state.favdata.filter(items=>items!==action.data)}
  case "ADDFAVKFRS":
    return{...state,favkfrs:action.data.data[0]}
  case "ADDFILTER":
    return{...state,filtered:[...state.filtered,action.data]}
  default:
    return state
  }
}

export default reduceer